import { render } from "./SenderPartialCutter.html?vue&type=template&id=823b2384"
import script from "./SenderPartialCutter.js?vue&type=script&lang=js"
export * from "./SenderPartialCutter.js?vue&type=script&lang=js"

import "./SenderPartialCutter.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__